var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pre',{ref:"code",staticClass:"syntax-highlight grey lighten-4 pa-4",class:_vm.lang,staticStyle:{"width":"100%","height":"inherit"}})}
var staticRenderFns = []

export { render, staticRenderFns }